import { defineMessages } from "react-intl";

import {
	hivScreeningMessages,
	validator
} from "lib/build/forms/ltx/phase-i/viral-serology/hiv";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hiv: {
		id: "form.hiv",
		defaultMessage: "HIV"
	},
	hivScreening: {
		id: "form.hiv.hiv_screening",
		defaultMessage: "HIV szűrés"
	}
});

const fields: { [key: string]: FieldData } = {
	hivScreening: {
		type: "field",
		path: ["hivScreening"],
		label: messages.hivScreening,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hivScreeningMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.hivScreening }] }]
};

export const node: LeafNode = {
	id: "hiv",
	value: {
		title: messages.hiv,
		validator,
		fieldset,
		isImportant: true
	}
};
